import { ReactNode } from 'react';

/**
 * Wraps a date/time value (or any single-line text) so it never wraps to
 * a second line inside a fixed-width table cell. Use for "Date/Time",
 * "Scheduled for", "Opt In Date" and similar columns.
 */
export const NoWrapCell = ({ children }: { children: ReactNode }) => (
  <span className="whitespace-nowrap">{children ?? '-'}</span>
);
